import {useBreakpointValue} from '@chakra-ui/react'

export const useIsMobile = () => {
  return useBreakpointValue([true, null, null, false], 'base')
}
